var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8557 26.1362H2.1443C0.957514 26.1362 0 25.1787 0 23.9919V10.5192C0 9.33239 0.957514 8.37488 2.1443 8.37488H17.8557C19.0425 8.37488 20 9.33239 20 10.5192V23.9919C20 25.1787 19.029 26.1362 17.8557 26.1362ZM2.1443 9.19754C1.40256 9.19754 0.809158 9.79093 0.809158 10.5327V24.0054C0.809158 24.7471 1.40256 25.3405 2.1443 25.3405H17.8557C18.5974 25.3405 19.1908 24.7471 19.1908 24.0054V10.5327C19.1908 9.79093 18.5974 9.19754 17.8557 9.19754H2.1443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.062 9.00875C15.8328 9.00875 15.6575 8.83343 15.6575 8.60417V6.27106C15.6575 3.26365 13.2165 0.809158 10.1956 0.809158C7.18814 0.809158 4.73365 3.25016 4.73365 6.27106V8.60417C4.73365 8.83343 4.55832 9.00875 4.32906 9.00875C4.09979 9.00875 3.92447 8.83343 3.92447 8.60417V6.27106C3.92447 2.8186 6.72961 0 10.1956 0C13.648 0 16.4666 2.80512 16.4666 6.27106V8.60417C16.4666 8.81994 16.2913 9.00875 16.062 9.00875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99324 18.0715C8.8604 18.0715 7.94336 17.1544 7.94336 16.0216C7.94336 14.8887 8.8604 13.9717 9.99324 13.9717C11.1261 13.9717 12.0431 14.8887 12.0431 16.0216C12.0566 17.1544 11.1261 18.0715 9.99324 18.0715ZM9.99324 14.8348C9.33242 14.8348 8.80647 15.3608 8.80647 16.0216C8.80647 16.6824 9.33242 17.2084 9.99324 17.2084C10.6541 17.2084 11.18 16.6824 11.18 16.0216C11.18 15.3608 10.6541 14.8348 9.99324 14.8348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99324 17.2084V21.2542",
    stroke: "white",
    strokeWidth: 0.8165,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.de7b60c54f07445caa2c96d419eb89a9.svg";
export { ForwardRef as ReactComponent };